import { Component } from 'react';

export class TooltipExclamationMarkSVG extends Component<{
    className?: string;
}> {
    render() {
        const { className } = this.props;

        return (
            <svg
                className={className}
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
                    fill="#DE1E1E"
                />
                <path
                    d="M6.85603 7.71429V8.71429C6.85603 8.79167 6.82775 8.85863 6.77121 8.91518C6.71466 8.97173 6.64769 9 6.57031 9H5.42746C5.35007 9 5.28311 8.97173 5.22656 8.91518C5.17001 8.85863 5.14174 8.79167 5.14174 8.71429V7.71429C5.14174 7.6369 5.17001 7.56994 5.22656 7.51339C5.28311 7.45685 5.35007 7.42857 5.42746 7.42857H6.57031C6.64769 7.42857 6.71466 7.45685 6.77121 7.51339C6.82775 7.56994 6.85603 7.6369 6.85603 7.71429ZM6.98996 3L6.86496 6.42857C6.86198 6.50595 6.83073 6.57292 6.77121 6.62946C6.71466 6.68601 6.64769 6.71429 6.57031 6.71429H5.42746C5.35007 6.71429 5.28162 6.68601 5.2221 6.62946C5.16555 6.57292 5.13579 6.50595 5.13281 6.42857L5.00781 3C5.00484 2.92262 5.03013 2.85565 5.08371 2.79911C5.14025 2.74256 5.20722 2.71429 5.2846 2.71429H6.71317C6.79055 2.71429 6.85603 2.74256 6.9096 2.79911C6.96615 2.85565 6.99293 2.92262 6.98996 3Z"
                    fill="white"
                />
            </svg>
        );
    }
}
